import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IonContent,  IonPage, IonAlert, IonIcon } from '@ionic/react';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import axiosInstance from '../services/AxiosInstance';
import styles from './css/Profile.module.css';
import { ribbon, podium } from 'ionicons/icons';


interface ProfileProps extends RouteComponentProps {
    // Define the props here
}

interface ProfileState {
    // Define the state here
    organisation: string,
    userName: string,
    firstName: string,
    lastName: string,
    profilePicture: string,
    ShowAlert: boolean,
}

class ProfilePage extends React.Component<ProfileProps, ProfileState>
{
    constructor(props: ProfileProps) {
        super(props);

        this.state = {
            organisation: "",
            userName: "",
            firstName: "",
            lastName: "",
            profilePicture: "",
            ShowAlert: false,
        }
    }
    
    componentDidMount(): void {
        this.getUserData();
    }
    
    async getUserData() {
        var token = localStorage.getItem("token");
        //var id = await localStorage.getItemAsync("id");
        var organisationId = localStorage.getItem("organisationId");
        var userName = localStorage.getItem("userName");
        var firstName = localStorage.getItem("firstName");
        var lastName = localStorage.getItem("lastName");

        this.setState({ firstName: firstName as string });
        this.setState({ lastName: lastName as string });
        this.setState({ userName: userName as string });
        
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        
        try {
            axiosInstance.get("/Organisations/" + organisationId, config).then((response) => {
                this.setState({ organisation: response.data.organisationName });
            });

            this.getImageData();
        } catch (error) {
            console.log(error);
        }
    }

    async getImageData() {
        var id = localStorage.getItem("id");
        var token = localStorage.getItem("token");

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        try {
            axiosInstance
                .get("/Photos/" + id, config)
                .then((response) => {
                    if (response != undefined) {
                        this.setState({ profilePicture: response.data.url });
                    }
                })
                .catch((error) => {
                    if (error.response.status == "500") {
                        console.log("Deze gebruiker heeft nog geen profielfoto.");
                    }
                    this.setState({ profilePicture: "" });
                });
        } catch (error) {
            console.log(error);
            this.setState({ profilePicture: "" });
        }
    }

    

    logout(): void {
        for (let i = localStorage.length - 1; i >= 0; i--) {
          const key = localStorage.key(i);
          if (key && key.includes("WelcomeSeen")) {
            continue; // Skip items with "WelcomeSeen" in the key
          }
          if(key)
          {
              localStorage.removeItem(key);            
          }
        }
        this.props.history.replace("/", "urlhistory");
      }   
      

    return(): void {
        const { history } = this.props;
        history.go(-1);
    }

    GoSettings(): void {
        const { history } = this.props;
        history.push("/Settings");
    }

    GoScore = () => {
        const { history } = this.props;
        history.push("/ScorePage");
    }

    GoToLevels = () => {
        const { history } = this.props;
        history.push("/LevelPage");
    }

    fileInputRef = React.createRef<HTMLInputElement>();

    handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        // handle the selected file here
        console.log(event.target.files);
        if (event.target.files != null) {
            let formData = new FormData();
            formData.append('formfile', event.target.files[0]);
            formData.append('userId', localStorage.getItem("id") as string);
            formData.append('fileName', event.target.files[0].name);

            await axiosInstance.post('Photos', formData, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
            }).then(() => {
                this.getImageData();
            })
                .catch((err) => { console.log(err) })
        }
    };

    handleClick = () => {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.click();
        }
    };

    removeImage = () => {
        var id = localStorage.getItem("id");
        var token = localStorage.getItem("token");

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        axiosInstance.delete("/Photos/" + id, config)
            .then(() => {
                this.getImageData();
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        return (
            <IonPage ion-no-header="true">
                <IonContent fullscreen ion-no-border="true">
                    <div style={{ backgroundColor: "white", height: "30vh", width: "100vw", backgroundImage: `url(${require("../assets/Profile4.png")})`, backgroundRepeat: 'repeat-x' }}></div>
                    <div style={{ backgroundColor: "white", height: "70vh", width: "100vw", display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100vw' }}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <img src={this.state.profilePicture.length == 0 ? require("../assets/generic-profile-icon-23.jpg") : this.state.profilePicture} className={styles.imageFromPicker} />
                                <FontAwesomeIcon
                                    icon={faEdit}
                                    color="#687089"
                                    onClick={() => this.handleClick()}
                                />
                                <FontAwesomeIcon
                                    icon={faTrashAlt}
                                    color="#D00000"
                                    onClick={() => { this.setState({ ShowAlert: true }) }}
                                    style={{
                                        marginLeft: "10px",
                                        display: this.state.profilePicture.length == 0 ? 'none' : 'inline-block'
                                    }}
                                />
                                <IonAlert
                                    isOpen={this.state.ShowAlert}
                                    header="Profielfoto verwijderen"
                                    message="Ben je zeker dat je je profielfoto wilt verwijderen?"
                                    buttons={[
                                        {
                                            text: "Ja",
                                            handler: this.removeImage,
                                        },
                                        {
                                            text: "Nee",
                                            handler: () => { this.setState({ ShowAlert: false }) }
                                        },
                                    ]}
                                />
                                <input
                                    type="file"
                                    ref={this.fileInputRef}
                                    onChange={this.handleFileChange}
                                    style={{ display: 'none' }}
                                    accept="image/*"
                                />
                            </div>
                            <div>
                                <p className={styles.userNameStyle}>{this.state.firstName} {this.state.lastName}</p>
                            </div>
                            <div>
                                <p className={styles.userOrganisationStyle}>{this.state.organisation}</p>
                            </div>

                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                    <IonIcon
                                    onClick={this.GoScore}
                                    icon={podium}
                                    className={styles.ChallengeButton}
                                    />
                                    <p className= {styles.badge}>Score</p>
                                </div>
                                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                    <IonIcon 
                                    onClick={this.GoToLevels}
                                    icon={ribbon}
                                    className={styles.ChallengeButton}/>
                                    <p className= {styles.badge}>Level</p>
                                </div>
                            </div>



                            {/* <div className={(styles.buttonViewStyle)}> */}
                            <button onClick={() => this.GoSettings()} className={(styles.addedMargin)} type='button'>
                                <p className={(styles.logout)}>App Info</p>
                            </button>
                            <button onClick={() => this.logout()} className={(styles.button)} type='button'>
                                <p className={(styles.logout)}>Uitloggen</p>
                            </button>
                            <button onClick={() => this.return()} className={(styles.button)} type='button'>
                                <p className={(styles.logout)}>Terug</p>
                            </button>
                            {/* </div> */}
                        </div>
                    </div>
                </IonContent>
            </IonPage>

        )
    }
}

export default withRouter(ProfilePage);
